export const fileTypes = {
  excel: ['.xls', '.xlsx'],
  jpg: ['.jpg', '.jpeg'],
  pdf: ['.pdf'],
  ppt: ['.ppt', '.pptx'],
  word: ['.doc', '.docx'],
  png: ['.png']
};
